import { THEME_LIGHT, THEME_DARK } from './types'
import { ThemeMap } from './Theme'

export const THEME_MAP: ThemeMap = {
  light: THEME_LIGHT,
  dark: THEME_DARK,
}
